/* eslint key-spacing: 'off', comma-spacing: 'off' */
//import VariableObject from '@/bo/VariableObject';

export default function VariableObject (variableName, variableTitle) {
  this.variable = variableName ? variableName : null;
  this.variableTitle = variableTitle ? variableTitle : null;
}

VariableObject.prototype.toString = function () {
  return this.variableTitle === null ? '' : this.variableTitle;
};

VariableObject.prototype.getVariableName = function () {
  return this.variable;
};

VariableObject.prototype.isSelected = function () {
  //return Boolean(this.variable);
  let results = this.variable && this.variable !== '';
  if (results === null)
    results = false;
  return results;
  // return this.variable && this.variable !== '';
};


VariableObject.copy = function (variable) {
  return variable === undefined || variable === null || variable.variable === null ? 
  new VariableObject() : new VariableObject(variable.variable, variable.variableTitle);
};

VariableObject.createFromVariable = function (variable) {
  return new VariableObject(variable.variable, variable.variableTitle);
};

//{
//  defaultObject: function () {
//    return {
//      year: year,
//      group: 1,
//      groupTitle: null,
//      variable: 'location',
//      variableTitle: 'Location',

//      //Properties from variable list
//      isRow: false,
//      isColumn: false,
//      isDependent: false,
//      isIndependent: false,
//      isControl: false,
//      isCategorical: false
//    };
//  }
//}
